import {Component} from '@angular/core'

@Component({
  selector: 'spb-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {
}
